import './../../scss/blocks/_imgwall.scss'
import initImgwallVideo from '../components/imgwallVideo'

document.addEventListener('DOMContentLoaded', () => {
    initImgwallVideo()
})
